import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { AgentNamesProvider } from './components/shared/AgentName';
import { getBrandName } from '@shared/config/brand';

// Branded tab title; also fails fast at boot when public/config.js has no brandName.
document.title = `${getBrandName()} Analytics`;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AgentNamesProvider>
        <App />
      </AgentNamesProvider>
    </BrowserRouter>
  </React.StrictMode>
);
